import { notEmpty, type Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useHook } from '../lenteHooks'

type Props = {
  postingType?: Optional<string>
}

export const useCollectivePotsAccountTypes = ({ postingType }: Props = {}) => {
  const tenantId = useHook('routing.tenant.useTenantParam')()

  const { data: accounts } = useHook(
    'fetchers.life.useFetchAllAccountSingletons',
  )({
    tenantId,
  })
  const { data: validAccountTypes } = useHook(
    'fetchers.life.useFetchPostingFrameAccountTypes',
  )(
    postingType
      ? {
          tenantId,
          postingType,
        }
      : null,
  )

  return useMemo(() => {
    const allAccounts =
      accounts?.accountVersions
        ?.filter(
          (accountVersion) => accountVersion?._type === 'BalanceAccountVersion',
        )
        .map((accountVersion) => accountVersion?.accountType)
        .filter(notEmpty)
        .sort() ?? []

    const filteredAccounts =
      validAccountTypes?.accountTypes
        ?.filter(notEmpty)
        .filter((accountType) => allAccounts.includes(accountType))
        .sort() ?? []

    return postingType ? filteredAccounts : allAccounts
  }, [accounts?.accountVersions, postingType, validAccountTypes?.accountTypes])
}
